import { FC } from 'react';
import FlatButton from '../../flat-button';
import ConversationHeader from '.';

interface Props {
  resourceId: string;
  onJumpToUserEvent?: () => void;
  fullWidth?: boolean;
}

const FullConversationHeader: FC<Props> = ({
  resourceId,
  onJumpToUserEvent,
  fullWidth = false,
}) => {
  if (!onJumpToUserEvent) {
    return <ConversationHeader resourceId={resourceId} />;
  }

  const JumpToUserEventEl = (
    <FlatButton label="Jump to User Event" onClick={onJumpToUserEvent} color="link" size="small" />
  );

  return (
    <ConversationHeader
      resourceId={resourceId}
      leftElement={JumpToUserEventEl}
      fullWidth={fullWidth}
    />
  );
};

export default FullConversationHeader;
